import { useCallback, useEffect, useState } from "react";

/**
 * Tela cheia na TV do salão.
 *
 * O navegador só concede `requestFullscreen` dentro de um gesto do usuário — o
 * botão "Iniciar" é a única hora em que isso acontece sem atrito. Falhar em
 * silêncio é o comportamento certo: em iOS não existe tela cheia para elemento
 * comum, e a projeção tem de rodar assim mesmo.
 */
export function useTelaCheia() {
  const [emTelaCheia, setEmTelaCheia] = useState(() => Boolean(document.fullscreenElement));

  useEffect(() => {
    const aoMudar = () => setEmTelaCheia(Boolean(document.fullscreenElement));
    document.addEventListener("fullscreenchange", aoMudar);
    return () => document.removeEventListener("fullscreenchange", aoMudar);
  }, []);

  const entrar = useCallback(async () => {
    if (document.fullscreenElement) return;
    try {
      await document.documentElement.requestFullscreen();
    } catch {
      // Sem tela cheia a galeria continua; só fica com a barra do navegador.
    }
  }, []);

  const sair = useCallback(async () => {
    if (!document.fullscreenElement) return;
    try {
      await document.exitFullscreen();
    } catch {
      // Idem: sair da projeção não pode depender disto.
    }
  }, []);

  return { emTelaCheia, entrar, sair };
}
